import classNames from 'classnames';
import { func, node, string } from 'prop-types';

import CloseButton from '~/components/ButtonIcons/CloseButton';
import PopupPlain, {
  propTypes as popupPlainPropTypes,
} from '~/components/PopupPlain';

import style from './PopupButtoned.module.scss';

function PopupButtoned({
  onClose,
  cancel,
  onSubmit,
  okay,
  children,
  onCloseButtonClick = onClose,
  className,
  contentClassName,
  buttonsClassName,
  ...props
}) {
  return (
    <PopupPlain
      containerClassName={style.modalContainer}
      className={classNames(style.modal, className)}
      onClose={onClose}
      fullscreen
      Button={CloseButton}
      buttonClassName={style.close}
      {...props}
    >
      <div className={classNames(style.content, contentClassName)}>
        {children}
      </div>
      <div className={classNames(style.buttons, buttonsClassName)}>
        {cancel && (
          <button
            className={style.reject}
            onClick={onCloseButtonClick}
          >
            <span>{cancel}</span>
          </button>
        )}
        <button
          onClick={onSubmit}
          className={style.accept}
        >
          <span>{okay} </span>
        </button>
      </div>
    </PopupPlain>
  );
}

export const propTypes = {
  ...popupPlainPropTypes,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  okay: node.isRequired,
  className: string,
  children: node,
  cancel: node,
  onCloseButtonClick: func,
  contentClassName: string,
  buttonsClassName: string,
};

PopupButtoned.propTypes = propTypes;

PopupButtoned.defaultProps = {
  open: true,
};

export default PopupButtoned;
